<template>
  <VuePhoneNumberInput ref="phoneInput" :default-country-code="$props.defaultCountry" v-model="value" @update="updateValue"/>
</template>

<script>
//import Vue from 'vue'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

//Vue.component('vue-phone-number-input', VuePhoneNumberInput);
//Vue.use(VuePhoneNumberInput);
export default {
  name: "PhoneInput",
  components: {
    VuePhoneNumberInput
  },
  props:{
    defaultCountry: {
      type: String,
      default: 'CO'
    }
  },
  data(){
    return {
      value: ''
    }
  },
  mounted() {
    // Espera a que se monte completamente y luego forzar el país
    this.$nextTick(() => {
      this.$refs.phoneInput.setCountry && this.$refs.phoneInput.setCountry('CO')
    })
  },
  methods: {
    updateValue(payload) {
      let result = payload
      console.log(result)
      if(result.formattedNumber){
        this.$emit('input', result.formattedNumber);
      }

    },
    setValue(payload) {
      this.value = payload
    }
  }
}
</script>

<style scoped>

</style>
